import { render, staticRenderFns } from "./UsersAdmin.vue?vue&type=template&id=64dba610&scoped=true"
import script from "./UsersAdmin.vue?vue&type=script&lang=ts"
export * from "./UsersAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dba610",
  null
  
)

export default component.exports